<template>
  <v-card>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="headline">Tags</v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="dialog_form" v-model="valid">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="dialog_add_key"
                    autocomplete="off"
                    :rules="nameRules"
                    label="Key"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="dialog_add_value"
                    :rules="nameRules"
                    autocomplete="off"
                    label="Value"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="onAdd"
                  >
                    Add
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Tag Name</th>
                  <th class="text-left">Tag Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tag in tags" :key="tag.haystackkey">
                  <td>{{ tag.haystackkey }}</td>
                  <td>{{ tag.haystackvalue }}</td>
                  <td @click="onTagDelete(tag)">❌</td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtered_key"
              :rules="nameRules"
              autocomplete="off"
              label="Key"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="filtered_value"
              :rules="nameRules"
              autocomplete="off"
              label="Value"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-btn
              :disabled="!valid"
              color="filtered_add"
              class="mr-4"
              @click="onAddFiltered"
            >
              Add
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-subtitle>
      You can search to filter results here. You can then add a tag above and it will only apply to the filtered results.
    </v-card-subtitle>

    <v-data-table
      :headers="headers"
      :items-per-page="-1"
      hide-default-footer
      @click:row="handleClick"
      @current-items="getFiltered"
      :items="data"
      :search="search"
      :loading="loading"
      loading-text="Loading... Please wait"
    ></v-data-table>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import Sites from "@/components/Sites.vue";
import Points from "@/components/Points.vue";
import { IRefInfo, IPointHaystackTag } from "@/main";

@Component({
  components: {
    Sites,
    Points,
  },
})
export default class TaggingManager extends Vue {
  public $refs!: {
    form: any;
  };

  public namespace_map: Map<string, IRefInfo> = new Map();

  public dialog_point_selected: IRefInfo | undefined = undefined;
  public dialog_add_key: string = "";
  public dialog_add_value: string = "";

  public filtered_key: string = "";
  public filtered_value: string = "";

  public valid: boolean = false;

  public nameRules = [
    (v: any) => !!v || "Field is required",
    (v: any) => (v && v.length <= 30) || "Name must be less than 30 characters",
  ];

  public headers = [
    {
      text: "Namespace",
      align: "left",
      sortable: false,
      value: "namespace",
    },
    { text: "Friendly Name", units: "", align: "left", value: "friendly_name" },
    { text: "ref", units: "", align: "left", value: "ref" },
  ];

  public data: any[] = [];
  public filteredData: any[] = [];
  public search: any = "";
  public loading = true;
  public dialog: boolean = false;
  public tags: IPointHaystackTag[] = [];

  public async created() {
    return;
  }

  public async mounted() {
    const self = this;

    self.$store.watch(
      (state) => {
        return this.$store.state.currentSiteGroup; // Does not seem to work with Getter
      },
      (newValue, oldValue) => {
        self.update();
      },
      // Optional Deep if you need it
      {
        deep: true,
      }
    );

    self.update();

    return;
  }

  public async update() {
    const self = this;

    self.loading = true;
    self.data = [];

    self.namespace_map = await self.$store.dispatch("requestNamespaceRefMap");

    for (let entry of Array.from(self.namespace_map.entries())) {
      let key = entry[0];
      let value: IRefInfo = entry[1];
      self.data.push({
        namespace: value.namespace,
        friendly_name: value.dis,
        ref: value.ref,
      });
    }

    self.loading = false;
  }

  // request_haystack_tags_add
  private async handleClick(value: IRefInfo) {

    const self = this;

    this.tags = await this.$store.dispatch("request_haystack_tags", {
      bmos_ids: [value.ref],
    });

    self.dialog_add_key = "";
    self.dialog_add_value = "";
    self.dialog_point_selected = value;
    self.dialog = true;
  }

  public getFiltered(e: any) {
    this.filteredData = e;
  }

  public validate() {
    this.$refs.form.validate();
  }

  public reset() {
    this.$refs!.form.reset();
  }

  public resetValidation() {
    this.$refs!.form.resetValidation();
  }

  public async onAdd() {

    const self = this;

    this.$refs!.form.validate();

    await this.$store.dispatch("request_haystack_tags_add", {
      bmos_ids: [self.dialog_point_selected!.ref],
      tags: [[self.dialog_add_key, self.dialog_add_value]],
    });

    self.tags.push({point: self.dialog_point_selected!.ref, haystackkey: self.dialog_add_key, haystackvalue: self.dialog_add_value});

    self.dialog_add_key = "";
    self.dialog_add_value = "";
    // self.dialog_point_selected = undefined;
    // self.dialog = false;
  }

  public async onTagDelete(tag: IPointHaystackTag) {

    const self = this;

    await this.$store.dispatch("request_haystack_tags_delete", {
      bmos_ids: [self.dialog_point_selected!.ref],
      tags: [[tag.haystackkey, tag.haystackvalue]],
    });

    const indexOfObject = self.tags.findIndex(object => {
      return object.point === tag.point && object.haystackkey === tag.haystackkey && object.haystackvalue === tag.haystackvalue;
    });

    self.tags.splice(indexOfObject, 1);
  }

  public async onAddFiltered() {
    const self = this;

    let refs = this.filteredData.map((r: IRefInfo) => r.ref);

    await this.$store.dispatch("request_haystack_tags_add", {
      bmos_ids: refs,
      tags: [[self.filtered_key, self.filtered_value]],
    });

    self.filtered_key = "";
    self.filtered_value = "";
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>